export const CHAT_VERSION = "3.1.1-beta.1775770505";
//# sourceMappingURL=version.js.map